import { apiRequest } from './client';

export interface FaqEntry {
  id: string;
  question: string;
  answer: string;
  sortOrder: number;
  visible: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface FaqInput {
  question: string;
  answer: string;
  sortOrder?: number;
  visible?: boolean;
}

export const fetchPublicFaq = async (): Promise<FaqEntry[]> => (await apiRequest<{ items: FaqEntry[] }>('/public/faq')).items;

export const fetchFaq = async (): Promise<FaqEntry[]> => (await apiRequest<{ items: FaqEntry[] }>('/faq')).items;

export const createFaq = (input: FaqInput): Promise<FaqEntry> => apiRequest<FaqEntry>('/faq', { method: 'POST', body: input });

export const updateFaq = (id: string, input: Partial<FaqInput>): Promise<FaqEntry> =>
  apiRequest<FaqEntry>(`/faq/${id}`, { method: 'PATCH', body: input });

export const deleteFaq = (id: string): Promise<void> => apiRequest<void>(`/faq/${id}`, { method: 'DELETE' });

export const reorderFaq = async (ids: string[]): Promise<FaqEntry[]> =>
  (await apiRequest<{ items: FaqEntry[] }>('/faq/reorder', { method: 'POST', body: { ids } })).items;
